<template>
    <footer class="footer">
        <div class="footrt_container">
            <!-- 上半部分 -->
            <div class="footer-top">
                <!-- 左边部分 -->
                <div class="footer-left">
                    <div class="contact-number" @click="handleContactClick">
                        <span class="phone-number text_bold">400-0068-930</span>
                        <span class="service-text text_bold">全国统一客服热线</span>
                    </div>
                <!-- 中间部分 -->
                    <div class="footer-center">
                        <div class="nav-row">
                          <router-link to="/">企业官网</router-link>
                          <router-link to="/about">关于我们</router-link>
                          <router-link to="/list">资讯动态</router-link>
                          <!-- <router-link >选择语言</router-link> -->
                          <!-- <div>企业官网</div>
                          <div>选择语言</div> -->
                        </div>
                        <div class="nav-row">
                          
                          <!-- <router-link to="/"  @click="goToHomeAndScroll('new_features')" >全新功能</router-link> -->
                          <a href="/" @click.prevent="goToHomeAndScroll('new_features')" rel="nofollow">全新功能</a>
                          <!-- <router-link to="/"  @click="goToHomeAndScroll('application_scenarios')" >应用场景</router-link> -->
                          <a href="/" @click.prevent="goToHomeAndScroll('application_scenarios')" rel="nofollow">应用场景</a>
                          <router-link to="/toAgentRegister">合作伙伴</router-link>
                          <!-- <div>关于我们</div>
                          <div>产品功能</div>
                          <div>使用场景</div>
                          <div>合作伙伴</div> -->
                        </div>
                        <div class="nav-row">
                          <a href="https://app.930pm.cn/home.php/Login/index" target="_blank" rel="noopener noreferrer nofollow">
                            商户后台
                          </a>
                          <div v-if="route.path !== '/toRegister'">
                            <router-link to="/toRegister">免费体验</router-link>
                            <router-link to="/toRegister">联系我们</router-link>
                          </div>
                          <!-- <div>商户后台</div>
                          <div>免费体验</div>
                          <div>联系我们</div> -->
                        </div>
                    </div>
                </div>
        
                
        
                <!-- 右边部分 -->
                <div class="footer-right">
                    <p class="social-title">官方自媒体</p>
                    <div class="social-container">
                      <a
                        v-for="(social, index) in socialItems"
                        :key="index"
                        class="social-item"
                        @click="showQRCode(index)"
                      >
                        <img :src="social.icons" :alt="social.alt" />
                        <span>{{ social.name }}</span>
                    </a>
                    </div>
                    <div v-if="showModal" class="modal" @click="closeModal">
                      <div class="modal-content">
                        <img :src="currentQRCode" alt="QR Code" class="qr-code-image" />
                      </div>
                    </div>
                  </div>
                </div>
            <!-- 下半部分 -->
            <div class="footer-bottom">
                <div class="address-row">
                    <div class="address">
                        <span>北京</span>
                        <span>北京市东城区金宝街2号快易名商206</span>
                    </div>
                    <div class="address">
                        <span>东莞</span>
                        <span>广东省东莞市南城街道宏北路20号恒兆中心614</span>
                    </div>
                    <div class="address">
                        <span>新加坡</span>
                        <span>78 SHENTON WAY #24-01A SINGAPORE (079120)</span>
                    </div>
                </div>
                <div class="footer-info">
                    <div class="logo">
                      <img :src="logoImage" alt="Logo" />
                    </div>
                    <div class="copyright">
                      <span>Copyright © 2016-2022 北京智合云鼎科技有限公司所有</span>
                      <span style="margin-left: 40px;">京ICP备14045973号-4</span>
                    </div>
                  </div>
            </div>
        </div>
    </footer>
  </template>
  
  <script>
    import { ref ,nextTick} from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { imagePath } from '@/utils/imagePath';
    // Import images
    import logoImage from '@/assets/images/logo.png';
    // import icon1 from '@/assets/images/icon1.png';
    // import icon2 from '@/assets/images/icon2.png';
    // import icon3 from '@/assets/images/icon3.png';
    // import icon4 from '@/assets/images/icon4.png';
    // import icon5 from '@/assets/images/icon5.png';
    // import icon6 from '@/assets/images/icon6.png';    
    
    // import icon1 from 'https://wcdn.930pm.cn/images/icon1.png';
    // import icon2 from 'https://wcdn.930pm.cn/images/icon2.png';
    // import icon3 from 'https://wcdn.930pm.cn/images/icon3.png';
    // import icon4 from 'https://wcdn.930pm.cn/images/icon4.png';
    // import icon5 from 'https://wcdn.930pm.cn/images/icon5.png';
    // import icon6 from 'https://wcdn.930pm.cn/images/icon6.png';
    

    import qrCode1 from '@/assets/images/fv/gzh-d.png';
    import qrCode2 from '@/assets/images/fv/sph-d.png';
    import qrCode3 from '@/assets/images/fv/tiktok-d.png';
    import qrCode4 from '@/assets/images/fv/red-d.png';
    import qrCode5 from '@/assets/images/fv/Instagram-d.png';
    import qrCode6 from '@/assets/images/fv/Facebook-d.png';

    
    export default {
      data() {
        return {
          showModal: false,
          currentQRCode: '',
          logoImage: logoImage,
          socialItems: [
            { name: '微信公众号', icons: 'https://wcdn.930pm.cn/images/icon1.png', alt: '微信公众号', qrCode: imagePath(qrCode1) },
            { name: '视频号', icons: 'https://wcdn.930pm.cn/images/icon2.png', alt: '视频号', qrCode: imagePath(qrCode2) },
            { name: '抖音', icons: 'https://wcdn.930pm.cn/images/icon3.png'  , alt: '抖音', qrCode: imagePath(qrCode3) },
            { name: '小红书', icons: 'https://wcdn.930pm.cn/images/icon4.png'  , alt: '小红书', qrCode: imagePath(qrCode4) },
            { name: 'Instagram', icons: 'https://wcdn.930pm.cn/images/icon5.png'  , alt: 'Instagram', qrCode: imagePath(qrCode5)  },
            { name: 'Facebook', icons: 'https://wcdn.930pm.cn/images/icon6.png'  , alt: 'Facebook', qrCode: imagePath(qrCode6)  }
          ]
        };
      },
      setup() {
        const route = useRoute();
        const router = useRouter();
        // console.log('router',router)
        return {
          route,
          router
        };
      },
      methods: {
        showQRCode(index) {
          this.currentQRCode = this.socialItems[index].qrCode;
          this.showModal = true;
        },
        closeModal() {
          this.showModal = false;
        },
        // 跳转至首页并滚动到指定锚点
        goToHomeAndScroll(anchor) {
        // showSidebar.value = false; // 关闭弹框
        if (this.route.name === 'home') {
          console.log('是首页');
          // 如果当前是首页，直接滚动到锚点
          const element = document.getElementById(anchor);
          if (element) {
            this.scrollToAnchor(anchor);
          }
        } else {
          console.log('不是首页');
          // 如果不是首页，先跳转至首页
          this.router.push({ name: 'home' }).then(() => {
            // 使用 nextTick 确保 DOM 更新完成后再滚动
            nextTick(() => {
              setTimeout(() => {
                this.scrollToAnchor(anchor);
              }, 1000);
            });
          });
        }
      },
       // 滚动到指定锚点
       scrollToAnchor (anchor) {
        const element = document.getElementById(anchor);
        if (element) {
          const rect = element.getBoundingClientRect();
          window.scrollTo({
            top: rect.top + window.scrollY - 50, // 锚点定位后再加50px
            behavior: 'smooth'
          });
        }
      },
        // goToHomeAndScroll(anchor) {
        //   if (this.route.name === 'home') {
        //     const element = document.getElementById(anchor);
        //     if (element) {
        //       const rect = element.getBoundingClientRect();
        //       window.scrollTo({
        //         top: rect.top + window.scrollY - 50,
        //         behavior: 'smooth'
        //       });
        //     }
        //   } else {
        //     this.router.push({ name: 'home' }).then(() => {
        //       const element = document.getElementById(anchor);
        //       if (element) {
        //         const rect = element.getBoundingClientRect();
        //         window.scrollTo({
        //           top: rect.top + window.scrollY - 50,
        //           behavior: 'smooth'
        //         });
        //       }
        //     });
        //   }
        // },
        handleContactClick() {
          if (/Mobi|Android/i.test(navigator.userAgent)) {
            window.location.href = 'tel:400-0068-930';
          }
        }
      }
    };
    </script>
  
  <style scoped>


.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
}

.qr-code-image {
  max-width: 100%;
  height: auto;
}
  .footer {
    width: 100%;
    height: 480px;
    background-color: #000;
    color: #ccc;
    padding: 40px 0;
  }
  .footrt_container{
    width: 1366px;
    margin: 0 auto;
  }
  .footer-top {
    display: flex;
    justify-content: space-between;
    margin-top:50px;
  }
  
  .footer-left {
    display: flex;
    flex-direction: row;
    justify-content: center
  }
  
  .contact-number {
    width: 260px;
    display: flex;
    flex-direction: column;
  }
  
  .phone-number {
    font-weight: bold;
    font-size: 32px;
    line-height: 30px;
    color: #fff;
  }
  
  .service-text {
    font-weight: bold;
    font-size: 28px;
    color: #007bff;
  }
  
  .footer-center {
    width: 300px;
    font-size: 12px;
    margin-left: 10px;
  }
  
  .nav-row {
    padding-bottom: 30px;
    display: flex   ;
    justify-content: flex-start;
  }
  
  .nav-row a {
    float: left;
    margin: 0 10px;
    cursor: pointer;
    color: #fff;
  }
  
  .footer-right {
    flex: 1;
    justify-content: flex-end;
  }
  
  .social-title{
    font-size: 12px;
    color: #ccc;
    margin-bottom: 40px;
    text-align: right;
  }
  
  .social-icons {
  display: flex;
  justify-content: space-between;
  width: 440px;
  float: right;
}

.social-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.social-item img {
  width:50px;
  height: 50px;
  margin-bottom: 5px;
}

.social-item span {
  font-size: 10px;
  color: #ccc;
}
  
  .footer-bottom {
    font-size: 12px;
    margin-top: 20px;
  }
  
  .address-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #999;
  }
  
  .address {
   margin-bottom: 10px;
  }
  
  .address span {
    display: block;
    text-align: left;
  }
  .footer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo{
    margin-top: 20px;
}
.logo img {
  width: 220px; /* 根据需要调整logo大小 */
}

.copyright {
  font-size: 11px;
  color: #ccc;
}
.social-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.social-item {
  cursor: pointer;
  text-align: center;
}
@media (min-width: 768px) and (max-width: 1366px) {
  .footrt_container{
    width: 90%;
  }
  .footer-top {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
  }
    .footer-right{
      display: flex;
      flex-direction: column;   
      align-items: center;
    }
    .social-title{display: none;}
    .social-item{
      margin: 0 10px;
    }
}
@media screen and (max-width: 768px) {
  .footrt_container{
    width: 90%;
  }
    .footer {
    height: auto;
    padding-bottom: 90px;
  }
  .footer-left{
    margin: 0 auto;  
    flex-direction: column;
    align-items: center;
}
  .footer-top {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 0;
  }
  .contact-number{
    text-align: center;
  }
  .footer-center {
    margin: 5px auto 20px;
  }
  
  .address-row {
    flex-direction: column;
  }
  .nav-row{
    padding: 5px 0;
  }
  .footer-info {
    flex-direction: column;
    align-items: normal;
    text-align: center;
  }
  
  .copyright span:last-child {
    margin-left: 0 !important;
    display: block;
  }
  
  .footer-right {
    justify-content: flex-start;
  }
  
  .social-icons {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .address{
    text-align: center;
    display: flex;
    justify-content: center;
}
.address span:first-child{
   margin-right: 10px   ;
}
  .social-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px; /* 增加底部间距 */
  }
  .social-title{
    text-align: left;
    margin-left: 10px;
    margin:10px 0 5px 10px;
    display: none;
  }
  .nav-row {
    padding: 10px 0;
    justify-content: center;
  }
  .address span{
    text-align: center;
  }
  .address-row{
    padding-bottom: 10px;
  }
  .modal-content {
    max-width: 300px; /* 在移动端设置较小的最大宽度 */
    width: 70%; /* 在移动端设置较小的宽度 */
  }
}
  </style>